import React from "react";
import { Coffee } from "lucide-react";

export const FloatingTip = () => (
    <a
        data-testid="floating-tip-btn"
        href="https://buymeacoffee.com/leonardthepreacher"
        target="_blank"
        rel="noreferrer"
        title="Tip the preacher"
        aria-label="Send a tip via Buy Me a Coffee"
        className="fixed bottom-5 left-5 z-50 inline-flex items-center gap-2 bg-hotpink text-white font-anton uppercase tracking-wider text-sm px-4 py-3 border-2 border-black shadow-[4px_4px_0_#000] hover:-translate-y-0.5 hover:shadow-[6px_6px_0_#53FC18] transition-all"
    >
        <Coffee className="w-4 h-4" strokeWidth={3} />
        <span className="hidden sm:inline">Send a Tip</span>
        <span className="sm:hidden">Tip</span>
    </a>
);
